/**
 * Format timestamp for display
 */
export function formatTime(date) {
  try {
    const tz = 'America/New_York';
    return new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      month: 'short',
      day: 'numeric'
    }).format(date);
  } catch {
    return date.toLocaleString();
  }
}

